import { SaveBarProps } from '@/components/SaveBar';
import { useUI } from '@/providers/UIProvider';
import { useEffect, useCallback } from 'react';
const useSaveBar = ({
  onSave,
  onDiscard,
  isSaving,
  isDirty,
}: {
  onSave: () => void;
  onDiscard: () => void;
  isSaving?: boolean;
  isDirty: boolean;
}) => {
  const { setSaveBar } = useUI();

  useEffect(() => {
    return () => {
      setSaveBar(null);
    };
  }, [setSaveBar]);

  useEffect(() => {
    setSaveBar({ onSave, onDiscard, open: isDirty, isSaving, isDirty });
  }, [isDirty, isSaving, onDiscard, onSave, setSaveBar]);

  const forceHideSaveBar = useCallback(() => {
    setSaveBar(null);
  }, [setSaveBar]);

  return { forceHideSaveBar };
};

export default useSaveBar;
